import { useTranslation } from 'react-i18next';
import NovartisLiveChatButton from './novartis-live-chat-button';
import { buildNovartisContactFormUrl, cn, isNovartisInstance, trimQuery } from '../../lib/utils';
import { CURRENT_INSTANCE } from '../../tenant';
import { Button } from '../ui/button';

interface NovartisContactFormButtonProps {
  align?: 'left' | 'center';
  onLiveChatStart?: () => void;
  query?: string;
}

function NovartisContactFormButton(props: NovartisContactFormButtonProps) {
  const { t } = useTranslation();
  const query = trimQuery(props.query || '');
  const chatClasses = CURRENT_INSTANCE.theme.classes?.chat;

  if (!isNovartisInstance() || !query) {
    return null;
  }

  return (
    <div
      className={cn(
        'mt-4 flex flex-col gap-2 sm:flex-row',
        props.align === 'center' ? 'justify-center' : 'justify-start'
      )}
    >
      <Button
        asChild
        className={cn(
          'bg-[hsl(var(--xircle-secondary))] text-white hover:bg-[hsl(var(--xircle-main))]',
          chatClasses?.followUpButton
        )}
      >
        <a
          className="text-white no-underline hover:text-white hover:no-underline"
          href={buildNovartisContactFormUrl(query)}
          target="_blank"
          rel="noreferrer"
        >
          {t('chat.medical_info.prefill_contact_form')}
        </a>
      </Button>
      <NovartisLiveChatButton inline onStart={props.onLiveChatStart} query={query} />
    </div>
  );
}

export default NovartisContactFormButton;
